import React from 'react';
import { enumValue } from '~/util';
import { Notes } from '../Notes';

interface QualityGapAuditNotesProps {
    entityId: number;
    gap: GapType;
}
export function QualityGapAuditNotes({ entityId, gap }: QualityGapAuditNotesProps) {
    return (
        <Notes
            canAdd={false}
            entityId={entityId}
            gap={gap}
            includeActions
            noteEntity="quality_gap.id"
            noteType={enumValue(['note', 'type', 'Quality Gap Note']) as number}
        />
    );
}
